import * as htmlToImage from "html-to-image";

const exportAsImage = (cb) => {
  cb(true);
  const element = document.getElementById("rewardShareFB");
  htmlToImage
    .toPng(element)
    .then(function (dataUrl) {
      var link = document.createElement("a");
      link.download = "my-reward.png";
      link.href = dataUrl;
      link.click();
      cb(false);
    })
    .catch((e) => {
      console.error(e);
      cb(false);
    });
};

export default exportAsImage;
